import React from 'react';
import { observer } from 'mobx-react';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';
import DeviceSettingsComponent from './Device-settings.component';
import useDeviceSettings from './useDeviceSettings';
import { Moment } from 'moment';

const Container = ({ onClose }: ICloseEvent) => {
    const { devices, user, app, lang, state, handlers, values } =
        useDeviceSettings(onClose);

    return (
        <>
            <DeviceSettingsComponent
                page={app.page}
                tab={state.tab}
                mode={state.mode}
                modes={devices.modes}
                demoModeError={app.demoModeError}
                imei={devices.settingDeviceImei}
                deviceName={values.deviceName}
                deviceType={values.deviceType}
                alarmError={state.alarmError}
                alarmState={state.alarmState}
                wakeUpTime={state.wakeUpTime}
                alarmAction={state.alarmAction}
                wakeUpActiveTime={state.wakeUpActiveTime}
                serverError={devices.serverError}
                noRightsError={devices.noRightsError}
                coordTxPeriod={state.coordTxPeriod}
                coordTxPeriodError={state.coordTxPeriodError}
                periodicActiveTime={state.periodicActiveTime}
                periodicActiveTimeError={state.periodicActiveTimeError}
                periodicSleepTimeError={state.periodicSleepTimeError}
                periodicSleepDays={state.periodicSleepDays}
                periodicSleepDaysError={state.periodicSleepDaysError}
                periodicSleepHours={state.periodicSleepHours}
                periodicSleepHoursError={state.periodicSleepHoursError}
                periodicSleepMinutes={state.periodicSleepMinutes}
                periodicSleepMinutesError={state.periodicSleepMinutesError}
                periodicLocationPeriod={state.periodicLocationPeriod}
                periodicLocationPeriodError={state.periodicLocationPeriodError}
                motionSensorMode={state.motionSensorMode}
                motionSensorModes={devices.selectedDeviceSettings.motionSensorModes ?? []}
                motionSensorAmpModes={devices.selectedDeviceSettings.motionSensorAmpModes ?? []}
                alarmActions={devices.selectedDeviceSettings.alarmActions ?? []}
                periodStart={state.periodStart}
                periodEnd={state.periodEnd}
                periodStartAndEndError={state.periodStartAndEndError}
                accelerometerAmp={state.accelerometerAmp}
                ignoreTime={state.ignoreTime}
                isNotIgnore={state.isNotIgnore}
                preliminaryAlarmSend={state.preliminaryAlarmSend}
                preliminaryAlarmSendSupported={
                    values.preliminaryAlarmSendSupported
                }
                motionSensorIgnoreTimeError={state.motionSensorIgnoreTimeError}
                smsState={state.smsState}
                smsFormat={state.smsFormat}
                smsFormats={devices.selectedDeviceSettings.smsFormats ?? []}
                phoneNumSim1={state.phoneNumSim1}
                phoneNumSim2={state.phoneNumSim2}
                serverState={state.serverState}
                serverProtocol={state.serverProtocol}
                serverAddress={state.serverAddress}
                serverPort={state.serverPort}
                serverPassword={state.serverPassword}
                mainSim={state.mainSim}
                simApn={state.simApn}
                simLogin={state.simLogin}
                simPassword={state.simPassword}
                dnsAddress={state.dnsAddress}
                timeSyncSatsState={state.timeSyncSatsState}
                timeSyncGsmState={state.timeSyncGsmState}
                timeSyncNtpState={state.timeSyncNtpState}
                timeSyncSatsSupported={values.timeSyncSatsSupported}
                timeSyncGsmSupported={values.timeSyncGsmSupported}
                timeSyncNtpSupported={values.timeSyncNtpSupported}
                ntpAddress={state.ntpAddress}
                ntpPort={state.ntpPort}
                gnssPowersave={state.gnssPowersave}
                gnssMinSearchTime={state.gnssMinSearchTime}
                gnssMinSearchTimeError={state.gnssMinSearchTimeError}
                gnssMaxSearchTime={state.gnssMaxSearchTime}
                gnssMaxSearchTimeError={state.gnssMaxSearchTimeError}
                gnssRectificationTime={state.gnssRectificationTime}
                ftpAddress={state.ftpAddress}
                ftpPort={state.ftpPort}
                ftpLogin={state.ftpLogin}
                ftpPassword={state.ftpPassword}
                ftpDirectory={state.ftpDirectory}
                ftpFilename={state.ftpFilename}
                ledState={state.ledState}
                settingsShareVisible={state.settingsShareVisible}
                desktopMode={state.desktopMode}
                lang={lang.lang}
                advancedMode={state.advancedMode}
                closeALert={state.closeALert}
                status={devices.selectedDeviceStatus}
                deviceTimezone={state.deviceTimezone}
                selectedDeviceApplied={devices.selectedDeviceApplied}
                selectedDeviceCommandStatus={
                    devices.selectedDeviceCommandStatus
                }
                selectedDeviceCommandFailureReason={
                    devices.selectedDeviceCommandFailureReason
                }
                selectedDeviceSettingsTs={devices.selectedDeviceSettingsTs}
                selectedDeviceCommandCreatedAt={
                    devices.selectedDeviceCommandCreatedAt
                }
                settingsLoading={devices.settingsLoading}
                savedAlertVisible={state.savedAlertVisible}
                timezone={user.settings.timezone}
                sensorMode={state.sensorMode}
                onTabChange={handlers.handleTabChange}
                onInputClick={handlers.handleInputClick}
                onModeChange={handlers.handleModeChange}
                onAlarmStateChange={handlers.handleAlarmStateChange}
                onWakeUpChange={handlers.handleWakeUpChange}
                onWakeUpError={handlers.handleWakeUpError}
                onAlarmActionChange={handlers.handleAlarmActionChange}
                onWakeUpActiveTimeChange={handlers.handleWakeUpActiveTimeChange}
                onCoordTxPeriodChange={handlers.handleCoordTxPeriodChange}
                onPeriodicActiveTimeChange={handlers.handlePeriodicActiveTimeChange}
                onPeriodicSleepDaysChange={handlers.handlePeriodicSleepDaysChange}
                onPeriodicSleepHoursChange={handlers.handlePeriodicSleepHoursChange}
                onPeriodicSleepMinutesChange={handlers.handlePeriodicSleepMinutesChange}
                onPeriodicLocationPeriodChange={handlers.handlePeriodicLocationPeriodChange}
                onMotionSensorModeChange={handlers.handleMotionSensorModeChange}
                onLightSensorModeChange={handlers.handleLightSensorModeChange}
                onSaveClick={handlers.handleSaveClick}
                onPeriodStartChange={handlers.handlePeriodStartChange}
                onPeriodEndChange={handlers.handlePeriodEndChange}
                onPeriodStartError={handlers.handlePeriodStartError}
                onPeriodEndError={handlers.handlePeriodEndError}
                onAccelerometerAmpChange={handlers.handleAccelerometerAmpChange}
                onNotIgnoreChange={handlers.handleNotIgnoreChange}
                onPreliminaryAlarmSendChange={
                    handlers.handlePreliminaryAlarmSendChange
                }
                onIgnoreTimeChange={handlers.handleIgnoreTimeChange}
                onIgnoreTimeError={handlers.handleIgnoreTimeError}
                onSmsStateChange={handlers.handleSmsStateChange}
                onSmsFormatChange={handlers.handleSmsFormatChange}
                onPhoneNumSim1Change={handlers.handlePhoneNumSim1Change}
                onPhoneNumSim2Change={handlers.handlePhoneNumSim2Change}
                onServerStateChange={handlers.handleServerStateChange}
                onServerProtocolChange={handlers.handleServerProtocolChange}
                onServerAddressChange={handlers.handleServerAddressChange}
                onServerPortChange={handlers.handleServerPortChange}
                onServerPasswordChange={handlers.handleServerPasswordChange}
                onMainSimChange={handlers.handleMainSimChange}
                onSimApnChange={handlers.handleSimApnChange}
                onSimLoginChange={handlers.handleSimLoginChange}
                onSimPasswordChange={handlers.handleSimPasswordChange}
                onDnsAddressChange={handlers.handleDnsAddressChange}
                onTimeSyncSatsStateChange={handlers.handleTimeSyncSatsStateChange}
                onTimeSyncGsmStateChange={handlers.handleTimeSyncGsmStateChange}
                onTimeSyncNtpStateChange={handlers.handleTimeSyncNtpStateChange}
                onNtpAddressChange={handlers.handleNtpAddressChange}
                onNtpPortChange={handlers.handleNtpPortChange}
                onGnssPowersaveChange={handlers.handleGnssPowersaveChange}
                onGnssMinSearchTimeChange={handlers.handleGnssMinSearchTimeChange}
                onGnssMaxSearchTimeChange={handlers.handleGnssMaxSearchTimeChange}
                onGnssRectificationTimeChange={handlers.handleGnssRectificationTimeChange}
                onFtpAddressChange={handlers.handleFtpAddressChange}
                onFtpPortChange={handlers.handleFtpPortChange}
                onFtpLoginChange={handlers.handleFtpLoginChange}
                onFtpPasswordChange={handlers.handleFtpPasswordChange}
                onFtpDirectoryChange={handlers.handleFtpDirectoryChange}
                onFtpFilenameChange={handlers.handleFtpFilenameChange}
                onLedStateChange={handlers.handleLedStateChange}
                onDeviceTimezoneChange={handlers.handleDeviceTimezoneChange}
                onSettingsShareOpen={handlers.handleSettingsShareOpen}
                onSettingsShareClose={handlers.handleSettingsShareClose}
                onAdvancedModeClick={handlers.handleAdvancedModeClick}
                onSettingsResetClick={handlers.handleSettingsResetClick}
                onCloseALertOpen={handlers.handleCloseALertOpen}
                onCloseALertClose={handlers.handleCloseALertClose}
                onCloseClick={handlers.handleCloseClick}
                onSaveAlertClose={handlers.handleSaveAlertClose}
                onClose={onClose}
                lsm={state.lsm}
                lssm={state.lssm}
                lsps={state.lsps}
                lspe={state.lspe}
                lightPeriodStartAndEndError={state.lightPeriodStartAndEndError}
                lsit={state.lsit}
                lightIsNotIgnore={state.lightIsNotIgnore}
                lightSensorIgnoreTimeError={state.lightSensorIgnoreTimeError}
                onLightSensorTriggerModeChange={handlers.handleLightSensorTriggerModeChange}
                onLightPeriodStartChange={handlers.handleLightPeriodStartChange}
                onLightPeriodStartError={handlers.handleLightPeriodStartError}
                onLightPeriodEndChange={handlers.handleLightPeriodEndChange}
                onLightPeriodEndError={handlers.handleLightPeriodEndError}
                onLightNotIgnoreChange={handlers.handleLightNotIgnoreChange}
                onLightIgnoreTimeChange={handlers.handleLightIgnoreTimeChange}
                onLightIgnoreTimeError={handlers.handleLightIgnoreTimeError}
                onSensorChange={handlers.handleSensorModeChange} 
                angleSensorMode={state.tsm} 
                anglePeriodStart={state.tsps}
                anglePeriodEnd={state.tspe}
                anglePeriodStartAndEndError={state.anglePeriodStartAndEndError}
                angleAmp={state.tsa}
                angleIsNotIgnore={state.angleIsNotIgnore}
                angleIgnoreTime={state.tsit}
                angleSensorIgnoreTimeError={state.angleSensorIgnoreTimeError}
                angleHoldingTime={state.tsaht}
                onAngleSensorModeChange={handlers.handleAngleSensorModeChange}
                onAnglePeriodStartChange={handlers.handleAnglePeriodStartChange}
                onAnglePeriodEndChange={handlers.handleAnglePeriodEndChange}
                onAnglePeriodStartError={handlers.handleAnglePeriodStartError}
                onAnglePeriodEndError={handlers.handlePeriodEndError}
                onAngleAmpChange={handlers.handleAngleAmpChange}
                onAngleNotIgnoreChange={handlers.handleAngleNotIgnoreChange}
                onAngleIgnoreTimeChange={handlers.handleAngleIgnoreTimeChange}
                onAngleIgnoreTimeError={handlers.handleAngleIgnoreTimeError}
                onAngleHoldingTimeChange={handlers.handleAngleHoldingTimeChange}
                
            />
        </>
    );
};

const DeviceSettingsContainer = observer(Container);

export default DeviceSettingsContainer;
